<template>
  <div class="checkMember">
    <el-dialog width="900px" title="选择会员" class="repair-dialog" :visible.sync="dialogVisible" :before-close="handleClose" center>
      <div class="p10">
        <div class=" flex-row wraps mb10">
          <el-cascader v-model="values" v-if="dialogVisible" popper-class="tests" :options="options" @expand-change="onExpandChange"  @change="handleChange" class=" checkMembers"></el-cascader>
          <div class="ml10" v-show="isPriceFlag">
            <el-input v-model="query.filterBegin" placeholder="金额起" class="width140"></el-input> - <el-input v-model="query.filterEnd" placeholder="金额止" class="width140"></el-input>
          </div>
          <div class="ml10" v-show="isTimeFlag">
            <el-date-picker v-model="query.filterBegin" type="date" placeholder="时间起" class="width140"></el-date-picker> - <el-date-picker v-model="query.filterEnd" type="date" placeholder="时间止" class="width140"></el-date-picker>
          </div>
          <div>
            <el-input v-model="query.cardName" v-show="isCardNameFlag" placeholder="请输入卡项名称" class="width160 ml10" maxlength="20" clearable></el-input>
            <el-input v-model="cardValue" v-show="isCardFlag" :placeholder="query.filterTypeVue == 'cardSurplus' ? '请输入次数':'请输入天数'" maxlength="8" class="width140 ml10"
            @input="cardValue=cardValue.replace(/[^\d]/g,'')" clearable></el-input>
          </div>
          <el-input v-model="query.keyword" placeholder="请输入会员手机号" :clearable="true" class="width160 ml10 mr10" maxlength="11"
          @input="query.keyword=query.keyword.replace(/[^\d]/g,'')"></el-input>
          <el-button type="primary" @click="handSearch">搜索</el-button>
        </div>
        <el-table
          ref="multipleProTable"
          :data="list"
          border
          max-height="430"
          @select-all="handleSelectionAll"
          @select="handleSelectionChange"
        >
          <!-- :selectable="selectable" -->
          <el-table-column type="selection" width="40" :selectable="selectable"></el-table-column>
          <el-table-column prop="realName" label="姓名" width="auto"></el-table-column>
          <el-table-column prop="mobile" label="电话号码" width="auto"></el-table-column>
          <el-table-column prop="walletAmount" label="余额" width="auto"></el-table-column>
          <el-table-column prop="consumeLastDate" label="最近消费" width="auto">
            <template slot-scope="scope">{{ formatDate(scope.row.consumeLastDate) }}</template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="flex-end">
          <paging :currentPage="query.start" :showSize="query.size" :totalCount="totalCount" @doPageQuery="handcurrentSearch"></paging>
          <!-- <el-button class="btn small-btn" @click="gotoOrderInfo">查看详情</el-button> -->
          <el-button class="btn small-btn" type="primary" @click="confirm">确定</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
export default {
  mixins: [minxin],
  props: {
    hintName: {
      type: String,
      default: null
    },
    amount: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      url: this.$url.smsTemplate.memberList,
      list: [],
      query: {
        start: 1,
        size: 20,
        memberStatus: 'enable',
        filterBegin: "",
        filterEnd: "",
        filterType: "",
        filterTypeVue: "",
        keyword: "",
        categoryId: "",
        repairStatus: "",
        cardName: '',
        leftCount: '',
        expireDay: ''
      },
      values: [],
      options: [
        {
          value: 'consumeTime',
          label: '最近消费',
          children: []
        },
        {
          value: 'birthDay',
          label: '会员生日',
          children: []
        },
        {
          value: 'registerTime',
          label: '注册时间',
          children: []
        },
        {
          value: 'consumeAmount',
          label: '累计消费',
          children: []
        },
        {
          value: 'rechargeAmount',
          label: '累计充值',
          children: []
        },
        {
          value: 'repair',
          label: '档案登记',
          children: []
        },
        {
          value: 'cardSurplus',
          label: '卡项剩余',
          children: []
        },
        {
          value: 'cardOverdue',
          label: '距卡过期',
          children: []
        },
      ],
      timeList: [
        { label: '不限', value: '', start: '', end: '' },
        {label: '7天内', value: '2', start: this.getBeforeDate(6), end: this.getBeforeDate(0), startTime: this.getAfterDate(0),endTime: this.getAfterDate(6)},
        {label: '8-15天', value: '3', start: this.getBeforeDate(14), end: this.getBeforeDate(7), startTime: this.getAfterDate(7),endTime: this.getAfterDate(14)},
        {label: '16-30天', value: '4', start: this.getBeforeDate(29), end: this.getBeforeDate(15), startTime: this.getAfterDate(15),endTime: this.getAfterDate(29)},
        {label: '31-90天', value: '5', start: this.getBeforeDate(89), end: this.getBeforeDate(30), startTime: this.getAfterDate(30),endTime: this.getAfterDate(89)},
        {label: '自定义时间', value: '6'},
      ],
      priceList: [
        {label: '不限', value: '', start:'', end: ''},
        {label: '0-100元', value: '2', start:'0', end: '100'},
        {label: '100-300元', value: '3', start:'100', end: '300'},
        {label: '300-500元', value: '4', start:'300', end: '500'},
        {label: '500元以上', value: '5', start:'500', end: ''},
        {label: '自定义金额', value: '6', start:'', end: ''},
      ],
      repairListItem: [
        {label: '不限', value: ''},
        {label: '进行中', value: 'handle'},
        {label: '已完成', value: 'finish'},
        {label: '已退款', value: 'refund'},
        {label: '期限内完成', value: 'intimeFinish'},
        {label: '逾期完成', value: 'outtimeFinish'},
        {label: '逾期未完成', value: 'outtimeUnfinish'},
      ],
      remainingCount: [
        {label: '不限', value: ''},
        {label: '小于3次', value: 3},
        {label: '小于6次', value: 6},
        {label: '自定义', value: -1},
      ],
      repairList: [],
      multipleSelection: [],
      list: [],
      isTimeFlag: false,
      isPriceFlag: false,
      isCardFlag: false,
      isCardNameFlag: false,
      cardValue: ''
    }
  },
  watch: {
    list() {
      for (let i in this.list) {
        let isExist = false;
        if (this.multipleSelection != undefined) {
          for (let j in this.multipleSelection) {
            if (this.multipleSelection[j].id == this.list[i].id) {
              isExist = true;
              break;
            }
          }
        }
        if (isExist) {
          this.list[i].selected = true;
          this.$nextTick(function() {
            this.$refs.multipleProTable.toggleRowSelection(this.list[i], true);
          });
        }
      }
    }
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$on("open", function(org) {
        this.dialogVisible = true;
        this.multipleSelection = [];
        this.options[0].children = this.timeList;
        this.options[1].children = this.timeList;
        this.options[2].children = this.timeList;
        this.options[3].children = this.priceList;
        this.options[4].children = this.priceList;
        this.options[6].children = this.remainingCount;
        this.options[7].children = this.timeList;
        if (org) {
          this.multipleSelection = JSON.parse(
            JSON.stringify(org)
          );
        }
        this.gettotalCount();
        this.getSelect();
      });
    },
    handcurrentSearch (val) {
			if (val.start || val.size) {
				this.query = Object.assign(this.query, val)
			} else {
				this.query = Object.assign(this.query, val)
				//this.query.start = 1
      }
      // if (val.start > 1) { 
      //   this.query.lastRecordId = this.list[this.list.length -1].id;
      // }
			this.getData();
		},
    gettotalCount () {
      this.query.filterType = (this.query.filterTypeVue == "cardSurplus" || this.query.filterTypeVue == "cardOverdue") ? 'card':this.query.filterTypeVue
      this.$api.post(this.$url.smsTemplate.memberList,this.query).then(res => {
        if (res) {
          res.map(item => {
            item.isSelected = false;
          })
          this.list = res;
        }
      }).catch(error => {})
      this.$api.post(this.$url.smsTemplate.countByShopId, this.query).then(res => {
        this.totalCount = res;
      }).catch(error => {});
    },
    getSelect() {
      this.$api.post(this.$url.smsTemplate.listRepairItem).then(res => {
        if (res) {
          this.repairList = res;
          let obj = {
            categoryName: '不限',
            categoryId: ''
          }
          this.repairList.unshift(obj);
          this.repairList.map(item => {
            item.label = item.categoryName;
            item.value = item.categoryId;
            item.children = this.repairListItem;
          })
          console.log(this.repairListItem);
          this.options[5].children = this.repairList;
        }
      })
    },
    handSearch () {
      if (this.cardValue) {
        if (this.query.filterTypeVue == 'cardSurplus') {
          this.query.expireDay = "";
          this.query.leftCount = this.cardValue;
        } else if (this.query.filterTypeVue == 'cardOverdue') {
          this.query.leftCount = "";
          this.query.expireDay = this.cardValue;
        }
      }
      if (!this.query.filterTypeVue && this.isCardNameFlag) {
        return this.$message.error(`请选择搜索选项`)
      }
      if (this.query.filterTypeVue == 'cardSurplus' || this.query.filterTypeVue == 'cardOverdue') {
        if (!this.query.cardName) {
          return this.$message.error(`请输入卡项名称`)
        } else if ((!this.cardValue || this.cardValue == 0) && this.isCardFlag) {
          return this.$message.error(`请输入${this.query.filterTypeVue == 'cardSurplus' ? '次数' : '天数'}`)
        }
      }
      this.query.start = 1;
      this.gettotalCount();
    },
    onExpandChange (value) {
      console.log(value, 'vassas');
      if (value.length > 0 && (value.includes('cardSurplus') || value.includes('cardOverdue'))) {
        this.isCardNameFlag = true
      } else {
        this.isCardNameFlag = false
      }
    },
    handleChange(value) {
      console.log(value, 'ssss');
      this.resetQuery();
      if (value.length == 2) {
        this.query.filterTypeVue = value[0];
        let obj = this.switchFunction(value[1]);
        console.log(obj, 'obj');
        if ((value.includes('cardSurplus'))) {
          this.query.leftCount = obj.msg1 || '';
        } else {
          this.query.filterBegin = obj.msg1 || '';
          this.query.filterEnd = obj.msg2 || '';
        }
        console.log(this.query, 'query');
        if (value[1] == '6' && (this.query.filterTypeVue == 'consumeTime' || this.query.filterTypeVue == 'birthDay' || this.query.filterTypeVue == 'registerTime')) {
          this.isTimeFlag = true;
        } else {
          this.isTimeFlag = false;
        }
        if (value[1] == '6' && (this.query.filterTypeVue == 'consumeAmount' || this.query.filterTypeVue == 'rechargeAmount')) {
          this.isPriceFlag = true;
        } else {
          this.isPriceFlag = false;
        }
        
        if ((value.includes('cardSurplus') && value[1] == -1 ) || (value.includes('cardOverdue') && value[1] == '6')) {
          this.isCardFlag = true;
        } else {
          this.isCardFlag = false;
        }
      } else if (value.length == 3) {
        this.isPriceFlag = false;
        this.isTimeFlag = false;
        this.isCardFlag = false;
        this.query.filterTypeVue = value[0];
        this.query.categoryId = value[1];
        this.query.repairStatus = value[2];
      }
    },
    switchFunction (value) {
      let msg1,msg2 = "";
      if (this.query.filterTypeVue == 'consumeTime' || this.query.filterTypeVue == 'birthDay' || this.query.filterTypeVue == 'registerTime' || this.query.filterTypeVue == 'cardOverdue') {
        this.timeList.map(item => {
          if (value == item.value) {
            msg1 = (this.query.filterTypeVue == 'birthDay' || this.query.filterTypeVue == 'cardOverdue') ? item.startTime:item.start;
            msg2 = (this.query.filterTypeVue == 'birthDay' || this.query.filterTypeVue == 'cardOverdue') ? item.endTime:item.end;
          }
        })
      } else if (this.query.filterTypeVue == 'consumeAmount' || this.query.filterTypeVue == 'rechargeAmount') {
        this.priceList.map(item => {
          if (value == item.value) {
            msg1 = item.start;
            msg2 = item.end;
          }
        })
      } else if (this.query.filterTypeVue == 'cardSurplus') {
        this.remainingCount.map(item => {
          if (value == item.value) {
            msg1 = item.value;
          }
        })
      }
      
      return {msg1,msg2}
    },
    selectable(row, index) {
      return !row.show;
    },
    handleSelectionAll(rows) {
      if (rows.length != 0) {
        for (let i in rows) {
          this.multipleSelection.push(rows[i]);
        }
        for (let i in this.multipleSelection) {
          this.multipleSelection[i].selected = true;
        }
      } else {
        for (let i in this.list) {
          this.list[i].selected = false;
          for (let j in this.multipleSelection) {
            if (this.list[i].id == this.multipleSelection[j].id) {
              this.multipleSelection.splice(j, 1);
            }
          }
        }
      }
      //去重
      let obj = {};
      this.multipleSelection = this.multipleSelection.reduce((cur, next) => {
        obj[next.id] ? "" : (obj[next.id] = true && cur.push(next));
        return cur;
      }, []); //设置cur默认类型为数组，并且初始值为空的数组
    },
    handleSelectionChange(selection, row) {
      if (row.selected) {
        row.selected = false;
        for (let i in this.multipleSelection) {
          if (this.multipleSelection[i].id == row.id) {
            this.multipleSelection.splice(i, 1);
            break;
          }
        }
      } else {
        row.selected = true;
        this.multipleSelection.push(row);
      }
      //去重
      let obj = {};
      this.multipleSelection = this.multipleSelection.reduce((cur, next) => {
        obj[next.id] ? "" : (obj[next.id] = true && cur.push(next));
        return cur;
      }, []); //设置cur默认类型为数组，并且初始值为空的数组
    },
    confirm() {
      let obj = {};
      this.multipleSelection = this.multipleSelection.reduce((cur, next) => {
        obj[next.id] ? "" : (obj[next.id] = true && cur.push(next));
        return cur;
      }, []); //设置cur默认类型为数组，并且初始值为空的数组
      this.handleClose();
      this.$emit("changeMember", this.multipleSelection);
    },
    handleClose () {
      this.dialogVisible = false;
      this.resetQuery()
      this.values = [];
      this.isPriceFlag = false;
      this.isTimeFlag = false;
      this.isCardFlag = false;
      this.isCardNameFlag = false;
    },
    resetQuery () {
      this.query = {
        start: 1,
        size: 20,
        filterBegin: "",
        filterEnd: "",
        filterType: '',
        filterTypeVue: "",
        keyword: "",
        categoryId: "",
        repairStatus: "",
        memberStatus: 'enable',
      }
      this.cardValue = "";
    },
    getBeforeDate (date) { // 获取xx天之前的日期 data == 数字 如：3
      let data = date;
      let d = new Date();
      let year = d.getFullYear();
      let mon = d.getMonth() + 1;
      let day = d.getDate();
      if (day <= data) {
        if (mon > 1) {
          mon = mon - 1;
        } else {
          year = year - 1;
          mon = 12;
        }
      }
      d.setDate(d.getDate() - data);
      year = d.getFullYear();
      mon = d.getMonth() + 1;
      day = d.getDate();
      let s =
        year +
        "-" +
        (mon < 10 ? "0" + mon : mon) +
        "-" +
        (day < 10 ? "0" + day : day);
      return s;
    },
    getAfterDate (date) { // 获取xx天之前的日期 data == 数字 如：3
      let data = date;
      let d = new Date();
      let year = d.getFullYear();
      let mon = d.getMonth() + 1;
      let day = d.getDate();
      if (day <= data) {
        if (mon > 1) {
          mon = mon - 1;
        } else {
          year = year - 1;
          mon = 12;
        }
      }
      d.setDate(d.getDate() + data);
      year = d.getFullYear();
      mon = d.getMonth() + 1;
      day = d.getDate();
      let s =
        year +
        "-" +
        (mon < 10 ? "0" + mon : mon) +
        "-" +
        (day < 10 ? "0" + day : day);
      return s;
    },
  }
};
</script>
<style>
.payway-success .el-button + .el-button {
  margin-left: 0;
}
</style>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
/deep/ .el-dialog {
  // height: 261px;
  border-radius: 10px;
}
/deep/ .el-dialog__header {
  height: 50px;
  box-sizing: border-box;
  padding: 0 16px;
  line-height: 50px;
  text-align: center;
  .el-dialog__headerbtn {
    top: 13px;
    .el-dialog__close {
      color: #666;
      border: 1px solid #666;
      border-radius: 50%;
      padding: 2px;
      &:hover {
        color: @blue;
        border: 1px solid @blue;
        background: #fff;
      }
    }
  }
}
/deep/ .el-dialog__body {
  padding: 20px 20px 0;
  height: auto !important;
}

/deep/ .el-dialog__footer {
  text-align: center;
  padding-bottom: 10px;
  .normal-btn {
    margin-right: 50px;
  }
}

</style>
<style>
.tests .el-cascader-menu__wrap {
  height: 302px !important;
}
</style>
